import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Currency from './pages/currency';
import MainLayout from './layout/main-layout';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import CreateOrEditCoin from './pages/currency/createOrEdit';
import Wallet from './pages/wallet';
import CreateOrEditWallet from './pages/wallet/create-edit';
import Transactions from './pages/transaction';
import CreateEditTransaction from './pages/transaction/create-edit';
import PortfolioBalancing from './pages/portfolio-balancing';
import Account from './pages/account';
import Integrations from './pages/integrations';
import CreateEditIntegration from './pages/integrations/create-edit';
import LiquidityPoolPage from './pages/liquidity-pool';

function App() {
  return (
    <Routes>
      <Route path='/user/:id' element={<MainLayout />}>
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='cryptocurrency' element={<Currency />} />
        <Route path='cryptocurrency/create' element={<CreateOrEditCoin />}/>
        <Route path='transaction' element={<Transactions />} />
        <Route path='transaction/create' element={<CreateEditTransaction />} />
        <Route path='transaction/edit/:transactionid' element={<CreateEditTransaction />} />
        <Route path='balancing' element={<PortfolioBalancing />} />
        <Route path='wallet' element={<Wallet/>} />
        <Route path='wallet/create' element={<CreateOrEditWallet/>} />
        <Route path='wallet/edit/:walletid' element={<CreateOrEditWallet />} />
        <Route path='edit' element={<Account />} />
        <Route path='integrations' element={<Integrations />} />
        <Route path='integrations/create' element={<CreateEditIntegration />} />
        <Route path='integrations/edit/:integrationid' element={<CreateEditIntegration />} />
        <Route path='liquidity-pool' element={<LiquidityPoolPage />} />
      </Route>
      <Route path='/' element={<Navigate to="/login" replace />} />
      <Route path='/login' element={<Login />} />
    </Routes>
  );
}

export default App;
